import { lazy, Suspense } from 'react';
import { useLang } from '@/lib/LanguageContext';
import { useColophon } from '@/lib/ColophonContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';
import { ModalShell } from '@/components/shared/ModalShell';
import { ModalSkeleton } from '@/components/ui/ModalSkeleton';

/**
 * ColophonModal — Océanne (wrapper modal pur).
 * Contenu délégué à ColophonContent (single source).
 * Page SEO indexable : routes/colophon.tsx (ColophonContent variant="page").
 *
 * Phase 27.84 — lazy-load ColophonContent. Chunk dédié dans vite.config.ts.
 * ModalShell unmount son enfant quand isOpen=false ; le bundle ne s'évalue
 * qu'à la première ouverture.
 */
const ColophonContent = lazy(() =>
  import('./colophon-content').then((m) => ({ default: m.ColophonContent }))
);

export function ColophonModal() {
  const { lang } = useLang();
  const { isOpen, close } = useColophon();
  const text = ta(t.colophon, lang);

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={close}
      eyebrow={text.eyebrow}
      title={text.title}
      closeLabel={text.modal_close_label}
      ariaLabelledById="colophon-modal-title"
      printable
      printLabel={text.modal_print_label}
    >
      <Suspense fallback={<ModalSkeleton />}>
        <ColophonContent variant="modal" onClose={close} />
      </Suspense>
    </ModalShell>
  );
}
